/**
 * Перечисление всех возможных событий, новые типы событий добавлять сюда
 */
export default class EventTypes {
   /** События пересечения нижней границы блока offer-slider при скролле */
   static SCROLLED_BELOW_OFFER_SLIDER = 'scrolledBelowOfferSlider'
   static SCROLLED_ABOVE_OFFER_SLIDER = 'scrolledAboveOfferSlider'

   /** События пересечения нижней границы блока looking-for при скролле */
   static SCROLLED_BELOW_LOOKING_FOR = 'scrolledBelowLookingFor'
   static SCROLLED_ABOVE_LOOKING_FOR = 'scrolledAboveLookingFor'
}